export const RISK_MODEL_OPTIONS = [
	{ value: "Bonus Hunter", label: "Bonus Hunter" },
	{ value: "Bot", label: "Bot" },
	{ value: "Bot_our_tournaments", label: "Bot_our_tournaments" },
	{ value: "High Roller", label: "High Roller" },
	{ value: "Low-Risk Player", label: "Low-Risk Player" },
	{ value: "Loyal Player", label: "Loyal Player" },
	{ value: "Net Winner", label: "Net Winner" },
	{ value: "Other", label: "Other" },
	{ value: "Partner", label: "Partner" },
	{ value: "Scammer", label: "Scammer" },
	{ value: "Spam", label: "Spam" },
];

const RISK_MODEL_VALUES = new Set(RISK_MODEL_OPTIONS.map((option) => option.value));

export const normalizeRiskModelValues = (riskModel) => {
	const values = Array.isArray(riskModel)
		? riskModel
		: typeof riskModel === "string"
			? riskModel.split(",")
			: [];

	return [...new Set(
		values
			.map((value) => (value === null || value === undefined ? "" : String(value).trim()))
			.filter((value) => value && RISK_MODEL_VALUES.has(value))
	)];
};

export const getRiskModelSelectedOptions = (riskModel) => {
	const selectedValues = normalizeRiskModelValues(riskModel);

	return RISK_MODEL_OPTIONS.filter((option) => selectedValues.includes(option.value));
};
